var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('view-list',{attrs:{"list":_vm.list,"type":"collect","total":_vm.total},on:{"gallerySort":_vm.gallerySort}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }